import styled, { css } from 'styled-components';
import { rgba } from 'polished';
import {
  COLOR_GREEN,
  COLOR_RED,
  COLOR_DARK_PURPLE,
  COLOR_LIGHT_ORANGE,
  COLOR_WHITE,
} from '../../../assets/styles/colors';

export default styled.span`
  font-size: 14px;
  font-weight: bold;
  display: inline-block;
  border-radius: 8px;
  padding: 3px 16px 3px 16px;
  box-sizing: border-box;

  ${({ size }) =>
    size === 'small'
      ? css`
          padding: 0 8px;
        `
      : css`
          padding: 3px 16px 3px 16px;
        `};
  border: 2px solid transparent;

  ${({ colorStyle }) => {
    switch (colorStyle) {
      case 'GREEN':
        return `color:${COLOR_GREEN}; background:${rgba(COLOR_GREEN, 0.2)}`;
      case 'DARK_GREEN':
        return `color:${COLOR_WHITE}; background:${COLOR_GREEN}`;
      case 'RED':
        return `color:${COLOR_RED}; background:${rgba(COLOR_RED, 0.2)}`;
      case 'ORANGE':
        return css`
          color: ${COLOR_LIGHT_ORANGE};
          background: ${rgba(COLOR_LIGHT_ORANGE, 0.2)};
          svg {
            g {
              opacity: 1;
              stroke: ${COLOR_LIGHT_ORANGE};
            }
          }
        `;
      case 'OUTLINE_GRAY':
        return `color:${rgba(COLOR_DARK_PURPLE, 0.4)}; background:white; border: 2px solid ${rgba(
          COLOR_DARK_PURPLE,
          0.1
        )}`;
      default:
        return `color:${rgba(COLOR_DARK_PURPLE, 0.4)}; background:${rgba(COLOR_DARK_PURPLE, 0.1)}`;
    }
  }};

  .additional-info {
    font-weight: normal;
  }
  .table-cell-status {
    font-weight: normal;
    width: 100%;
    display: flex;
    justify-content: center;
    text-align: center;
    align-items: center;

    svg {
      margin-right: 6px;
    }
    &.bold {
      font-weight: bold;
    }
    b {
      padding-left: 3px;
    }
  }
`;
